module.exports = __webpack_public_path__ + "img/defaultprofilepic.6176ce0f.svg";